import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsOfService = () => {
    const { t } = useTranslation();

    return (
        <div className="page-transition">
            <div className="container mx-auto px-4 py-12 max-w-4xl">
                <h1 id="terms-top" className="text-4xl font-bold mb-8 text-center">{t('terms.title')}</h1>

                <div className="prose max-w-none">
                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.lastUpdated')}</h2>
                        <p className="text-gray-600 mb-8">July 2024</p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.introduction.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.introduction.description')}
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.acceptanceOfTerms.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.acceptanceOfTerms.description')}
                        </p>
                        <div className="bg-blue-50 p-6 rounded-lg">
                            <p className="text-gray-700">
                                {t('terms.acceptanceOfTerms.note')}
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.serviceDescription.title')}</h2>
                        <p className="text-gray-700 mb-4">{t('terms.serviceDescription.description')}</p>
                        <div className="space-y-3 text-gray-700 ml-4">
                            <div className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <p>{t('terms.serviceDescription.feature1')}</p>
                            </div>
                            <div className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <p>{t('terms.serviceDescription.feature2')}</p>
                            </div>
                            <div className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <p>{t('terms.serviceDescription.feature3')}</p>
                            </div>
                            <div className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <p>{t('terms.serviceDescription.feature4')}</p>
                            </div>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.userAccounts.title')}</h2>
                        <p className="text-gray-700 mb-4">{t('terms.userAccounts.description')}</p>
                        <ul className="space-y-2 text-gray-700 ml-4">
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userAccounts.responsibility1')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userAccounts.responsibility2')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userAccounts.responsibility3')}</span>
                            </li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.userConduct.title')}</h2>
                        <p className="text-gray-700 mb-4">{t('terms.userConduct.description')}</p>
                        <p className="text-gray-700 mb-4 font-semibold">{t('terms.userConduct.prohibited')}:</p>
                        <ul className="space-y-2 text-gray-700 ml-4">
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userConduct.prohibit1')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userConduct.prohibit2')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userConduct.prohibit3')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userConduct.prohibit4')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.userConduct.prohibit5')}</span>
                            </li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.subscriptions.title')}</h2>
                        <p className="text-gray-700 mb-4">{t('terms.subscriptions.description')}</p>
                        <div className="space-y-4">
                            <div>
                                <h3 className="text-lg font-semibold mb-2">{t('terms.subscriptions.billing')}</h3>
                                <p className="text-gray-700 ml-4">{t('terms.subscriptions.billingDesc')}</p>
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold mb-2">{t('terms.subscriptions.cancellation')}</h3>
                                <p className="text-gray-700 ml-4">{t('terms.subscriptions.cancellationDesc')}</p>
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold mb-2">{t('terms.subscriptions.refund')}</h3>
                                <p className="text-gray-700 ml-4">{t('terms.subscriptions.refundDesc')}</p>
                            </div>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.intellectualProperty.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.intellectualProperty.description')}
                        </p>
                        <div className="bg-yellow-50 p-6 rounded-lg">
                            <p className="text-gray-700">
                                {t('terms.intellectualProperty.rights')}
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.disclaimer.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.disclaimer.description')}
                        </p>
                        <div className="bg-red-50 border border-red-200 p-6 rounded-lg">
                            <p className="text-gray-700 font-semibold mb-2">
                                {t('terms.disclaimer.asIs')}
                            </p>
                            <p className="text-gray-700 text-sm">
                                {t('terms.disclaimer.asIsDesc')}
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.limitation.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.limitation.description')}
                        </p>
                        <ul className="space-y-2 text-gray-700 ml-4">
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.limitation.limit1')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.limitation.limit2')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.limitation.limit3')}</span>
                            </li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.indemnity.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.indemnity.description')}
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.termination.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.termination.description')}
                        </p>
                        <p className="text-gray-700 mb-4">
                            {t('terms.termination.grounds')}
                        </p>
                        <ul className="space-y-2 text-gray-700 ml-4">
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.termination.ground1')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.termination.ground2')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-blue-600 mr-3 mt-1">•</span>
                                <span>{t('terms.termination.ground3')}</span>
                            </li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.changes.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.changes.description')}
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.governing.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.governing.description')}
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">{t('terms.contact.title')}</h2>
                        <p className="text-gray-700 mb-4">
                            {t('terms.contact.description')}
                        </p>
                        <div className="bg-gray-50 p-6 rounded-lg">
                            <p className="text-gray-700 mb-2">
                                <strong>Email:</strong> legal@sokba.net
                            </p>
                            <p className="text-gray-700 mb-2">
                                <strong>Address:</strong> {t('terms.contact.address')}
                            </p>
                            <p className="text-gray-700">
                                <strong>Hours:</strong> {t('terms.contact.hours')}
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
